module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal custom-modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask modal-lg"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "width": "initial"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card"
  }), _vm._v(" " + _vm._s(_vm.contact.first_name) + " " + _vm._s(_vm.contact.last_name) + " "), _c('small', [_vm._v(_vm._s(_vm.contact.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pre-scrollable",
    style: ({
      'max-height': _vm.bodyHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "lead-detail"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Contact Information (" + _vm._s(_vm._f("formatTimestamp")(_vm.contact.timestamp)) + ")")]), _vm._v(" "), _c('ul', {
    staticClass: "contact-info"
  }, [(_vm.contact.email) ? _c('li', [_c('i', {
    staticClass: "fa fa-lg fa-at"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contact.email))])]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('li', [_c('i', {
    staticClass: "fa fa-lg fa-phone"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contact.phone))])]) : _vm._e(), _vm._v(" "), (_vm.contact.address) ? _c('li', [_c('i', {
    staticClass: "fa fa-lg fa-map-marker"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.contact.address))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Activity")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Event Type")]), _vm._v(" "), _c('th', [_vm._v("Event ID")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contact.activity), function(a) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatTimestamp")(a.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(a.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(a.object_id))])])
  }), 0)])]), _vm._v(" "), (Object.keys(_vm.contact.meta).length) ? _c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Metadata")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Field")]), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.contact.meta), function(v, k) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(k))]), _c('td', [_c('b', [_vm._v(_vm._s(v))])])])
  }), 0)])])]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a254ba4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ContactDataModal.vue
// module id = 620
// module chunks = 0